<template>
  <div id="Faq">
    <h1>Frequently Asked Questions</h1>
    <div class="line"></div>
    <div id="accordionContainer">
    <Accordion :accordionData="accordionData" />
    </div>
  </div>
</template>

<script>
import { faqData } from "@/data/faqData";
import { TweenLite } from "gsap/dist/gsap";
import Accordion from "@/components/sections/Faq/Accordion";
export default {
  name: "CoreBenefits",
  components: {
    Accordion
  },
  data() {
    return {
      accordionData: faqData(),
      selectedCategory: "",
      activeItemKey: ""
    };
  },
  methods: {
    itemClicked(itemId) {
      let currentActiveEle = document.getElementById(this.activeItemKey);
      let activeItemKeyCopy = this.activeItemKey;
      if (currentActiveEle) {
        this.activeItemKey = "";
        TweenLite.to(currentActiveEle, 0.5, {
          height: 0
        });
      }
      if (itemId != activeItemKeyCopy) {
        this.activeItemKey = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight
        });
      }
    }
  },
  mounted() {
    if (this.accordionData && Object.keys(this.accordionData).length > 0) {
      this.selectedCategory = Object.keys(this.accordionData)[0];
    }
  }
}
</script>

<style lang="scss" scoped>
  #Faq {
		width: 50%;
		margin: auto;
		margin-bottom: 100px;
		@media only screen and (max-width: $lg) {
			width: 90%;
		}
		h1 {
			font-family: 'UniversLTStd-UltraCn';
			color: $dark-blue;
			font-size: 50px;
			text-transform: uppercase;
		}
		.line{
			background-color: $yellow;
			width: 190px;
			height: 3px;
			margin: 10px 0;
		}
  }
</style>